import { useEffect, useState } from 'react';
import { aiModelService, type AIModel } from '../utils/aiModelService';

// Selected-model details enrich labels and estimates; their background lookup
// must not reject outside React or publish a previous selection's response.
export function useSelectedAIModel(modelId?: string | null): AIModel | null {
  const [loaded, setLoaded] = useState<{ id: string; model: AIModel | null } | null>(null);

  useEffect(() => {
    if (!modelId) return;
    let cancelled = false;
    const load = async () => {
      try {
        const model = await aiModelService.getModelById(modelId);
        if (!cancelled) setLoaded({ id: modelId, model: model ?? null });
      } catch {
        // The service reports the failure. Leave details unavailable so a later
        // selection can retry without turning a network outage into a page error.
        if (!cancelled) setLoaded({ id: modelId, model: null });
      }
    };
    void load();
    return () => { cancelled = true; };
  }, [modelId]);

  return modelId && loaded?.id === modelId ? loaded.model : null;
}
